import React from "react";

import { open, close, ContentProps, RenderConfirmation } from "services/popup";

type OpenPopupArguments = {
  key: string;
  render: (props: ContentProps) => React.ReactNode;
  canCloseByOuterClick?: boolean;
  withoutExitButton?: boolean;
  onClose?: () => void;
  confirmation?: {
    renderConfirmation: RenderConfirmation;
    shouldShowConfirmation: () => boolean;
  };
};

export type GlobalPopupProps = {
  openPopup: (args: OpenPopupArguments) => void;
  closePopup: () => void;
};

export default function withGlobalPopup(
  WrappedComponent: React.ComponentType<GlobalPopupProps>,
) {
  return class Wrapper extends React.Component {
    isOpened: boolean = false;

    componentWillUnmount(): void {
      if (this.isOpened) {
        close();
      }
    }

    openPopup = ({
      key,
      canCloseByOuterClick,
      withoutExitButton,
      render,
      onClose,
      confirmation,
    }: OpenPopupArguments) => {
      open(key, {
        render,
        canCloseByOuterClick,
        withoutExitButton,
        onClose: this.onClosePopup(onClose),
        confirmation,
      });
      this.isOpened = true;
    };

    onClosePopup = (onClose?: () => void) => () => {
      this.isOpened = false;
      onClose && onClose();
    };

    render() {
      return (
        <WrappedComponent
          {...this.props}
          openPopup={this.openPopup}
          closePopup={close}
        />
      );
    }
  };
}
